import {
    FETCH_POSITIVE_OR_NEGATIVE_RESULT_START,
    FETCH_POSITIVE_OR_NEGATIVE_RESULT_SUCCESS,
    FETCH_POSITIVE_OR_NEGATIVE_RESULT_FAILED
} from '../../constants';
import { FETCH_DRIVERS_URL, FETCH_SUB_CARD_POSITIVE_AND_NEGATIVE_URL } from '../../../../config/constants';
import { ApiBase } from '../../../utils/apiBase';
import { withType } from '../../../utils/actionOperations';
import { getProjectIdAndOrgId } from '../../../utils/apiUtils';

export const fetchPositiveAndNegativeData = (payload, cb) => {
    return (dispatch) => {
        payload.forEach((cardPayload, index) => {
            dispatch(callApiBasedOnPayload(cardPayload, { noOfApiCalls: payload.length }));
        });
      };
    };

const callApiBasedOnPayload = (payload, loaderDetails) => {
    const apiBaseInstance = new ApiBase();
    return dispatch => {
        let currentId = payload.currentId
        delete payload.currentId
        dispatch(withType(FETCH_POSITIVE_OR_NEGATIVE_RESULT_START, {}));
        apiBaseInstance.instance
            .post(FETCH_SUB_CARD_POSITIVE_AND_NEGATIVE_URL, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then(response => {
                dispatch(withType(FETCH_POSITIVE_OR_NEGATIVE_RESULT_SUCCESS, {
                    loadingDetailsData: loaderDetails,
                    currentId,
                    payload:payload,
                    data: response.data,
                    message: response.message,
                }));

            })
            .catch(err => {
                dispatch(withType(FETCH_POSITIVE_OR_NEGATIVE_RESULT_FAILED, {
                    error: err
                }));
            });
    };
}

